module.exports = __webpack_public_path__ + "img/banner03.9bb38089.jpg";